export default __webpack_public_path__ + "static/media/remove.e9b0f8ef.svg";